import getDefaultCountryForCurrency from '../../default-country-for-currency';
import sortByDeliverySpeedEstimate from '../../sortQuotesByDeliverySpeedEstimate';

function findHighestReceivedAmount(quotes) {
  const [quoteWithHighestReceivedAmount] = quotes.sort(
    (a, b) => b.receivedAmount - a.receivedAmount,
  );
  return quoteWithHighestReceivedAmount.receivedAmount;
}

function allQuotesWithHighestReceivedAmount(quotes) {
  const receivedAmount = findHighestReceivedAmount(quotes);
  return quotes.filter((q) => q.receivedAmount === receivedAmount);
}

function findDefaultCurrencyCountry(quotes, targetCurrency) {
  return (
    quotes.find((q) => q.targetCountry === getDefaultCountryForCurrency(targetCurrency)) ||
    quotes[0]
  );
}

function extractQuote(quotes, targetCurrency) {
  const quotesWithHighestReceivedAmount = allQuotesWithHighestReceivedAmount([...quotes]);
  const quotesWithFastestDeliverySpeedEstimate = sortByDeliverySpeedEstimate(
    quotesWithHighestReceivedAmount,
  );
  return findDefaultCurrencyCountry(quotesWithFastestDeliverySpeedEstimate, targetCurrency);
}

export default extractQuote;
